import moment from 'moment';
import BASE_URL from '../configs/baseUrl';

export const timeoutFunc = (timeout, action, delay) => {
  clearTimeout(timeout);
  return setTimeout(() => {
    action();
  }, delay);
};

export const validateEmail = (email) => {
  const re =
    // eslint-disable-next-line max-len
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const getNickName = (name) => {
  const x = name?.match(/\b\w/g) || [];
  return ((x.shift() || '') + (x.pop() || '')).toUpperCase();
};

export const isObjectEmpty = (value) => {
  return (
    Object.prototype.toString.call(value) === '[object Object]' &&
    JSON.stringify(value) === '{}'
  );
};

export const filterEmptyObject = (value) => {
  const data = {};
  Object.keys(value).forEach((key) => {
    if (value[key]) {
      data[key] = value[key];
    }
  });
  return data;
};

export const dateDiffHandler = (date1, date2) => {
  return Math.floor((date1.time - date2.time) / (1000 * 60 * 60 * 24));
};

export const sortValue = (object, option) => {
  return object.filter((opt) => {
    return opt.value === option;
  })[0];
};

export function numberFormatter(x) {
  if (x) {
    if (x % 1 !== 0) {
      return x
        .toString()
        .replace(/\./, ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  return 0;
}

export const onInputNumber = (event) => {
  if (
    !/[0-9]/.test(event.key) &&
    event.key !== 'Backspace' &&
    event.key !== '.' &&
    event.key !== 'ArrowRight' &&
    event.key !== 'ArrowLeft' &&
    event.key !== 'Tab'
  ) {
    event.preventDefault();
  }
};

export const getAge = (dateString) => {
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1;
  }
  return age;
};

export const groupBy = (objectArray, property) => {
  return objectArray.reduce((acc, obj) => {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
};

export const sumByAttr = (params) => {
  const { dataSource = [], attr = '' } = params;
  const selectAttrs = attr.split('.');

  const total = dataSource.reduce((result, item) => {
    let selectedValue = item;
    selectAttrs.forEach((attrItem) => {
      selectedValue = selectedValue?.[attrItem] ?? 0;
    });
    result += parseFloat(selectedValue);
    return result;
  }, 0);

  return total;
};

export const arrToObj = (params) => {
  const { dataSource = [], attrKey = '' } = params;
  const result = {};
  dataSource.forEach((item) => {
    result[item[attrKey]] = item;
  });
  return result;
};

export const countObjectTotal = (params) => {
  const keys = Object.keys(params);
  let result = 0;
  keys.forEach((key) => {
    if (params?.[key]) {
      const parsedValue = parseFloat(params?.[key]);
      if (!Number.isNaN(parsedValue)) {
        result += parsedValue;
      }
    }
  });
  return result;
};

export const poIdFormatter = ({ purchaseOrder }) => {
  const { approvals, id } = purchaseOrder;

  const parsedId = () => {
    const tmpId = String(id);
    if (tmpId.length < 2) {
      return `0${tmpId}`;
    }
    return tmpId;
  };

  const hasPoId = approvals.reduce((res, current) => {
    return res && (current?.approval || false);
  }, true);

  const lastApproval = approvals?.[approvals?.length - 1];

  const currentDate = moment(lastApproval?.updated_at);

  if (currentDate.isValid()) {
    const month = currentDate.format('MM');
    const year = currentDate.format('YY');

    if (hasPoId) {
      return `${year}${month}${parsedId()}`;
    }
  }
  return '-';
};

export const loginRedirect = (params) => {
  if (params?.targetPath && params?.targetPath !== BASE_URL.LOGIN) {
    return `${BASE_URL.LOGIN}?redirect=${params?.targetPath}`;
  }
  return BASE_URL.LOGIN;
};

export const emptyWoPrintedItem = () => {
  return {
    item: null,
    item_qty: null,
    work_type: null,
    job: {
      job_description: null,
      man_hour: null,
      rate: null,
    },
    job_qty: null,
  };
};

export const enumerateDaysBetweenDates = ({ startDate, endDate }) => {
  const dates = [];

  const currDate = moment(startDate).endOf('day');
  const lastDate = moment(endDate).startOf('day');

  while (currDate.add(1, 'days').diff(lastDate) < 0) {
    dates.push(currDate.clone());
  }
  dates.push(lastDate);

  return dates;
};

export const parsingRepairRequest = (params) => {
  const splitted = params?.split('\n') ?? params;
  if (splitted?.length > 0) {
    return splitted.join(', ');
  }

  return params;
};
